// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav_nav__VHVL7","navWithBanner":"nav_navWithBanner__4sHZ5","navWithoutBanner":"nav_navWithoutBanner__2CME4"};